import React from "react";
import styles from "./index.module.scss";
export default class StepNumber extends React.Component {
    render() {
        return (React.createElement("div", { className: styles.wrapper },
            React.createElement("div", { className: styles.circle },
                React.createElement("div", { className: styles.number }, this.props.number))));
    }
}
